
import React from 'react';
import { Button } from '@/components/ui/button';

interface EmptyFilterResultsProps {
  resetFilter: () => void;
}

const EmptyFilterResults: React.FC<EmptyFilterResultsProps> = ({ resetFilter }) => {
  return (
    <div className="col-span-full flex items-center justify-center p-8 bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-dashed border-gray-300 dark:border-gray-700">
      <div className="text-center">
        <p className="text-gray-500 dark:text-gray-400">Aucune vidéo ne correspond à ce filtre</p>
        <Button 
          variant="outline" 
          size="sm" 
          className="mt-4 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
          onClick={resetFilter}
        >
          Afficher toutes les vidéos
        </Button>
      </div>
    </div>
  );
};

export default EmptyFilterResults;
